<script setup lang="ts">
defineProps<{ title: string }>()
</script>

<template>
  <div class="mb-3 flex items-center justify-center gap-4">
    <h1 class="flex flex-1 items-center gap-2">
      <slot name="beforeTitle" />
      {{ title }}
      <slot name="afterTitle" />
    </h1>
    <slot />
  </div>
</template>
